export default __webpack_public_path__ + "static/media/all-students.9eb2dbea.svg";